<template>
    <div class="va-footer">
        <span class="va-footer-text">
            <span>© Copyright {{ new Date().getFullYear() }} - Atticode GmbH</span>
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
